import { connect } from 'react-redux'
import ActivateUserPage from '../../ActivateUser/components/ActivateUserPage'
import { actions } from '../../ActivateUser/modules/ActivateUser'

const mapStateToProps = (state, ownProps) => {
  const { studyVersionID } = ownProps?.params || {}
  const { resetPassword, user } = state
  return { ...resetPassword, ...user, isPasswordChange: false, studyVersionID }
}

const mapDispatchToProps = actions

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(props => {
  return ActivateUserPage(props)
})
